<!-- 认证管理 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <div class="certificationManage">
      <div v-if="certificationState == 0">
        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px">
          <el-form-item label="证件类型" prop="CertType">
            <el-select v-model="formData.CertType" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in CertType"
                :key="item.TValue"
                :label="item.TValue"
                :value="item.TKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="CertNum">
            <el-input v-model.trim="formData.CertNum" v-filter-special-char="formData.CertNum"></el-input>
          </el-form-item>
          <el-form-item label="发证时间" prop="IssueDate">
            <el-date-picker
              value-format="yyyy-MM-dd"
              style="width: 100%"
              v-model="formData.IssueDate"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="过期时间" prop="ExpirationDate">
            <el-date-picker
              value-format="yyyy-MM-dd"
              style="width: 100%"
              v-model="formData.ExpirationDate"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="经营性质" prop="Data1">
            <el-input v-model.trim="formData.Data1" v-filter-special-char="formData.Data1"></el-input>
          </el-form-item>
          <el-form-item label="经营范围" prop="Data2">
            <el-input v-model.trim="formData.Data2" v-filter-special-char="formData.Data2"></el-input>
          </el-form-item>
          <el-form-item label="经营地址" prop="Data3">
            <el-input v-model.trim="formData.Data3" v-filter-special-char="formData.Data3"></el-input>
          </el-form-item>
          <el-form-item label="法人" prop="Data4">
            <el-input v-model.trim="formData.Data4" v-filter-special-char="formData.Data4"></el-input>
          </el-form-item>
          <el-form-item label="认证类型" prop="AuthType">
            <el-select v-model="formData.AuthType" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in AuthType"
                :key="item.TKey"
                :label="item.TValue"
                :value="item.TKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件图片" prop="CertImgUrl">
            <uploadFile type="EntpCredentials" @uploadSuccess="certImgSuccess"></uploadFile>
          </el-form-item>
          <el-form-item label="扫描件图片" prop="ScanImgUrl">
            <uploadFile type="EntpCredentials" @uploadSuccess="scanImgUrlSuccess"></uploadFile>
          </el-form-item>
          <el-form-item>
            <div style="text-align: right">
              <el-button
                class="btn-primary"
                @click="submitForm"
                v-if="permission.submit"
              >{{permission.submit}}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div v-else-if="certificationState == 1">
        <div class="certification-title">已提交认证，正在审核中</div>
        <div class="certification-item">
          <div class="key">证件类型</div>
          <div class="value">{{formData.CertTypeName}}</div>
        </div>
        <div class="certification-item">
          <div class="key">证件号码</div>
          <div class="value">{{formData.CertNum}}</div>
        </div>
        <div class="certification-item">
          <div class="key">发证时间</div>
          <div class="value">{{formData.IssueDate}}</div>
        </div>
        <div class="certification-item">
          <div class="key">过期时间</div>
          <div class="value">{{formData.ExpirationDate}}</div>
        </div>
        <div class="certification-item">
          <div class="key">经营性质</div>
          <div class="value">{{formData.Data1}}</div>
        </div>
        <div class="certification-item">
          <div class="key">经营范围</div>
          <div class="value">{{formData.Data2}}</div>
        </div>
        <div class="certification-item">
          <div class="key">经营地址</div>
          <div class="value">{{formData.Data3}}</div>
        </div>
        <div class="certification-item">
          <div class="key">法人</div>
          <div class="value">{{formData.Data4}}</div>
        </div>
        <div class="certification-item">
          <div class="key">认证类型</div>
          <div class="value">{{formData.AuthTypeName}}</div>
        </div>
        <div class="certification-item">
          <div class="key">证件图片</div>
          <div class="value">
            <img :src="download_url+formData.CertImgUrl" alt :onerror="defaultImg" class="zj" />
          </div>
        </div>
        <div class="certification-item">
          <div class="key">扫描件图片</div>
          <div class="value">
            <img :src="download_url+formData.ScanImgUrl" alt :onerror="defaultImg" class="zj" />
          </div>
        </div>
      </div>
      <div v-else-if="certificationState == 2">
        <div class="certification-title">已提交认证，认证成功</div>
        <div class="certification-item">
          <div class="key">证件类型</div>
          <div class="value">{{formData.CertTypeName}}</div>
        </div>
        <div class="certification-item">
          <div class="key">证件号码</div>
          <div class="value">{{formData.CertNum}}</div>
        </div>
        <div class="certification-item">
          <div class="key">发证时间</div>
          <div class="value">{{formData.IssueDate}}</div>
        </div>
        <div class="certification-item">
          <div class="key">过期时间</div>
          <div class="value">{{formData.ExpirationDate}}</div>
        </div>
        <div class="certification-item">
          <div class="key">经营性质</div>
          <div class="value">{{formData.Data1}}</div>
        </div>
        <div class="certification-item">
          <div class="key">经营范围</div>
          <div class="value">{{formData.Data2}}</div>
        </div>
        <div class="certification-item">
          <div class="key">经营地址</div>
          <div class="value">{{formData.Data3}}</div>
        </div>
        <div class="certification-item">
          <div class="key">法人</div>
          <div class="value">{{formData.Data4}}</div>
        </div>
        <div class="certification-item">
          <div class="key">认证类型</div>
          <div class="value">{{formData.AuthTypeName}}</div>
        </div>
        <div class="certification-item">
          <div class="key">证件图片</div>
          <div class="value" style="border: none">
            <img :src="download_url+formData.CertImgUrl" alt :onerror="defaultImg" class="zj" />
          </div>
        </div>
        <div class="certification-item">
          <div class="key">扫描件图片</div>
          <div class="value" style="border: none">
            <img :src="download_url+formData.ScanImgUrl" alt :onerror="defaultImg" class="zj" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import uploadFile from "@/components/common/uploadFile.vue";
export default {
  name: "",
  components: {
    uploadFile,
    breadcrumb
  },
  data() {
    return {
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      download_url: this.$util.QN_URL_BASE,
      certificationState: 0, // 0 未认证 1 认证中 2 已认证
      multiple: false,
      CertType: [],
      AuthType: [],
      formData: {
        EntpId: this.$util.getLocalStorage("userMsg").EntpId,
        AuthType: "",
        CertType: "",
        CertNum: "",
        IssueDate: "",
        ExpirationDate: "",
        Data1: "",
        Data2: "",
        Data3: "",
        Data4: "",
        CertImgUrl: "",
        ScanImgUrl: ""
      },
      rules: {
        AuthType: [{ required: true, message: "该项必填", trigger: "change" }],
        CertType: [{ required: true, message: "该项必填", trigger: "change" }],
        CertNum: [{ required: true, message: "该项必填", trigger: "blur" }],
        IssueDate: [{ required: true, message: "该项必填", trigger: "change" }],
        ExpirationDate: [
          { required: true, message: "该项必填", trigger: "change" }
        ],
        Data1: [{ required: true, message: "该项必填", trigger: "blur" }],
        Data2: [{ required: true, message: "该项必填", trigger: "blur" }],
        Data3: [{ required: true, message: "该项必填", trigger: "blur" }],
        Data4: [{ required: true, message: "该项必填", trigger: "blur" }],
        CertImgUrl: [
          { required: true, message: "该项必填", trigger: "change" }
        ],
        ScanImgUrl: [{ required: true, message: "该项必填", trigger: "change" }]
      },
      permission: {}
    };
  },
  mounted() {
    this.getEntpType();
    this.getEntpAuthInfo();
    this.permission = this.$util.getPermission("CertificationManage");
  },
  methods: {
    // 获取企业认证信息
    getEntpAuthInfo() {
      this.$util
        .axiosGet({
          url: "/api/EntpInfoManagement/EntpAuthInfo",
          data: {
            EntpId:this.formData.EntpId
          }
        })
        .then(res => {
          let data = res.data;
          if (data) {
            // 提交过认证了
            data.EntpId =this.formData.EntpId;
            this.formData = data;
            if (data.IsCheck) {
              // 认证成功了
              this.certificationState = 2;
            } else {
              // 认证审核中
              this.certificationState = 1;
            }
          } else {
            // 未提交过认证
            this.certificationState = 0;
          }
        });
    },
    // 配置类型列表
    getEntpType() {
      this.$util.getConfigData(`CertType,AuthType`).then(res => {
        let _CertType = [];
        let _AuthType = [];
        for (let i = 0; i < res.length; i++) {
          if (res[i].TypeCode == "CertType") {
            _CertType.push(res[i]);
          }
          if (res[i].TypeCode == "AuthType") {
            _AuthType.push(res[i]);
          }
        }
        this.CertType = _CertType;
        this.AuthType = _AuthType;
      });
    },
    // 证件图片上传成功
    certImgSuccess(res) {
      this.formData.CertImgUrl = res;
    },
    // 扫描件上传成功
    scanImgUrlSuccess(res) {
      this.formData.ScanImgUrl = res;
    },
    // 提交数据
    submitForm() {
      let formName = "formData";
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$util
            .axiosPost({
              url: "/api/EntpInfoManagement/SubmitAuth",
              data: this.formData
            })
            .then(() => {
              this.$util.successMsg("提交成功");
              this.getEntpAuthInfo();
            });
        } else {
          return false;
        }
      });
    },
    // 上传校验
    beforeAvatarUpload(file) {
      return this.$util.uploadCheck(file);
    }
  }
};
</script>
<style lang="less" scoped>
.zj {
  width: auto;
  height: 150px;
  margin-top: 10px;
}
.certificationManage {
  max-width: 1000px;
  margin: 0 auto;
}
.certification-title {
  text-align: center;
  font-size: @font-lg;
}
.certification-item {
  padding-top: 20px;
  display: flex;
  line-height: 36px;
  .key {
    width: 150px;
    text-align: right;
    padding-right: 20px;
  }
  .value {
    flex-grow: 1;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid @border1Color;
  }
}
</style>
